module.exports = __webpack_public_path__ + "702473e137e6e678eca8ad7ae62a1e7d.gif";